import { render, staticRenderFns } from "./SearchTag.vue?vue&type=template&id=51e577f7&scoped=true&"
import script from "./SearchTag.vue?vue&type=script&lang=js&"
export * from "./SearchTag.vue?vue&type=script&lang=js&"
import style0 from "./SearchTag.vue?vue&type=style&index=0&id=51e577f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e577f7",
  null
  
)

export default component.exports